import * as React from "react";
import WidgetHeader from "../common/widget-header";
import LFOLessons from "./lfo-lessons";
var LFOHeader = function (props) {
    return (React.createElement("div", { className: "column-top-section" },
        React.createElement(WidgetHeader, { title: props.title }),
        React.createElement(LFOLessons, { lessons: props.lessons, students: props.students, activeSubject: props.activeSubject, onLessonChange: props.onLessonChange, selectedLesson: props.selectedLesson, lessonMenuCallback: props.lessonMenuCallback, viewLessonCallback: props.viewLessonCallback, features: props.features })));
};
export default LFOHeader;
